import apiClient from './client';
import type { Facilitator, FacilitatorCreateRequest } from '@business-game/shared';

export const facilitatorsApi = {
  async getAllFacilitators(activeOnly = true): Promise<Facilitator[]> {
    const response = await apiClient.get('/facilitators', {
      params: { active: activeOnly },
    });
    const data = response.data?.data;
    return Array.isArray(data) ? data : [];
  },

  async createFacilitator(data: FacilitatorCreateRequest): Promise<Facilitator> {
    const response = await apiClient.post('/facilitators', data);
    const created = response.data?.data;
    if (!created?.name) {
      throw new Error('Invalid facilitator response');
    }
    return created;
  },
};
